/**
 * Manual de Usuario — content-as-data registry.
 *
 * Each role's manual lives in its own file. The list a user actually sees is
 * driven by the SAME AuthContext role helpers the sidebar uses — no parallel
 * role logic. Editing a manual = a code change + deploy (no DB, no admin UI).
 */
import { userIsAdmin, userHasRole } from '../context/AuthContext';

import chofer from './chofer';
import supervisor from './supervisor';
import engineer from './engineer';
import manager from './manager';
import reviewer from './reviewer';
import accountant from './accountant';
import admin from './admin';
import oficina from './oficina';

// Ordered by hierarchy so multi-role users get a stable nav order.
//
// ⚠ V61 — NO HAY MANUAL DE SOCIO(A), y es una omisión CONSCIENTE, no un olvido del barrido.
// El manual describe pantallas, y las del socio (aprobar/denegar una ausencia) todavía no
// existen: se construyen en la pieza 4. Escribirlo ahora sería documentar lo inexistente.
// ⚠ El modo de falla acá es BENIGNO y por eso se puede diferir: `getManualsForUser`
// devuelve [] y `ManualPage` muestra "No hay manual disponible para su rol" — un mensaje
// explícito, no una pantalla en blanco ni un rol suplantado. Es la única de las listas de
// roles del frontend que falla de forma legible sin estar enumerada.
export const MANUALS = [chofer, oficina, supervisor, engineer, manager, reviewer, accountant, admin];

/**
 * Returns the manuals visible to a user.
 * - Admin sees every manual (userIsAdmin).
 * - Everyone else sees the manual for each role they actually hold (userHasRole).
 * A user with several roles (e.g. supervisor + engineer) sees the union.
 */
export function getManualsForUser(user) {
  if (!user) return [];
  if (userIsAdmin(user)) return MANUALS;
  return MANUALS.filter(m => userHasRole(user, m.roleKey));
}
